<div class="app-container" [class.authenticated-view]="loginDisplay">
  
  <div class="logo-container">
    <img src="Logo - White.png" alt="YourExpats Logo" class="brand-logo">
  </div>

  @if (authLoaded) {
  
  @if (!loginDisplay) {
  <app-login (login)="login()"></app-login>
  }

  
  @else {
  <app-dashboard [firstName]="userFirstName()" [lastName]="userLastName()" [email]="userEmail()"
    [canOnboard]="canOnboard()" [canSelect]="canSelect()" [canFind]="canFind()" [canTest]="canTest()"
    [onboardUrl]="onboardUrl" [selectUrl]="selectUrl" [findUrl]="findUrl" [testUrl]="testUrl" (logout)="logout()">
  </app-dashboard>
  }
  }

  
  <footer class="footer-copyright" [ngClass]="{
    'footer-development': environment.name === 'development' || environment.name === 'local',
    'footer-testing': environment.name === 'testing'
  }">
    &copy; 2026 YourExpats. All rights reserved.
  </footer>
</div>